webpackJsonp([221662759943617,33342177194180],{

/***/ 1162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(178);
	
	var _hubspotFormSubmit = __webpack_require__(772);
	
	var _hubspotFormSubmit2 = _interopRequireDefault(_hubspotFormSubmit);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _messageBlock = __webpack_require__(65);
	
	var _messageBlock2 = _interopRequireDefault(_messageBlock);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _ContactUsInput = __webpack_require__(1324);
	
	var _ContactUsInput2 = _interopRequireDefault(_ContactUsInput);
	
	var _validation = __webpack_require__(154);
	
	var _params = __webpack_require__(123);
	
	var _api = __webpack_require__(54);
	
	var _forms = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = [{
	  label: 'Full Name',
	  name: 'name',
	  placeholder: "What's your full name?",
	  validate: _validation.isRequired
	}, {
	  label: 'Email address',
	  name: 'email',
	  type: 'email',
	  placeholder: 'you@example.com',
	  validate: [_validation.isRequired, _validation.isEmailValid]
	}, {
	  label: 'Message',
	  name: 'message',
	  placeholder: 'Write your message for the team here',
	  validate: _validation.isRequired
	}];
	
	var ContactForm = function (_React$Component) {
	  _inherits(ContactForm, _React$Component);
	
	  function ContactForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContactForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      formState: 'initial',
	      isLoading: false
	    }, _this.submitForm = function (data) {
	      _this.setState({ isLoading: true });
	
	      var _splitNames = (0, _forms.splitNames)(data.name),
	          firstName = _splitNames.firstName,
	          lastName = _splitNames.lastName;
	
	      var gclid = (0, _params.readCookie)('gclid');
	      (0, _hubspotFormSubmit2.default)(_api.HUBSPOT_ID, _this.props.hubspotId, {
	        company: data.company,
	        email: data.email,
	        firstname: firstName,
	        lastname: lastName,
	        message: data.message,
	        gclid: gclid
	      }).then(function () {
	        _this.setState({
	          formState: 'success',
	          isLoading: false
	        });
	      }).catch(function () {
	        _this.setState({
	          formState: 'error',
	          isLoading: false
	        });
	      });
	
	      if (typeof window !== 'undefined' && window.dataLayer) {
	        window.dataLayer.push({
	          event: 'form-submitted-contact-us'
	        });
	      }
	    }, _this.trackSubmissionWithHeap = function (submittedSuccessfully, hasErrored) {
	      if (window.heap) if (submittedSuccessfully) {
	        window.heap.track('Enterprise Form Submitted');
	      } else if (hasErrored) {
	        window.heap.track('Enterprise Form Error');
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ContactForm.prototype.render = function render() {
	    var _state = this.state,
	        formState = _state.formState,
	        isLoading = _state.isLoading;
	
	    var submittedSuccessfully = formState === 'success';
	    var hasErrored = formState === 'error';
	    this.trackSubmissionWithHeap(submittedSuccessfully, hasErrored);
	    return _react2.default.createElement(
	      _maxWidth2.default,
	      { display: 'block', value: 400 },
	      _react2.default.createElement(
	        'form',
	        {
	          onSubmit: this.props.handleSubmit(this.submitForm),
	          noValidate: true,
	          method: 'post'
	        },
	        hasErrored && _react2.default.createElement(
	          _messageBlock2.default,
	          { type: 'error' },
	          'There was an error submitting this form. Please try again or',
	          ' ',
	          _react2.default.createElement(
	            _link2.default,
	            {
	              url: 'https://help.marvelapp.com/',
	              type: 'opaqueReversed',
	              hasUnderline: true,
	              target: '_blank'
	            },
	            'contact support.'
	          )
	        ),
	        fields.map(function (field) {
	          return _react2.default.createElement(
	            _spacing2.default,
	            { key: field.name, type: 'margin', size: 'm', position: 'top' },
	            _react2.default.createElement(_reduxForm.Field, {
	              component: _ContactUsInput2.default,
	              fullWidth: true,
	              id: field.name,
	              isTextarea: field.name === 'message',
	              label: field.label,
	              minHeight: field.name === 'message' ? 120 : undefined,
	              name: field.name,
	              placeholder: field.placeholder,
	              popoverPosition: 'right',
	              popoverWidth: 300,
	              size: 'large',
	              type: field.type || 'text',
	              validate: field.validate
	            })
	          );
	        }),
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'padding', size: 'm', position: 'top' },
	          _react2.default.createElement(
	            _button2.default,
	            {
	              type: 'submit',
	              size: 'large',
	              background: submittedSuccessfully ? 'green' : 'blue',
	              hover: submittedSuccessfully ? 'green' : 'blue',
	              minWidth: 110,
	              fullWidth: true,
	              hasSucceeded: submittedSuccessfully,
	              hasErrored: hasErrored,
	              isStateful: true,
	              isLoading: isLoading
	            },
	            'Submit'
	          )
	        )
	      )
	    );
	  };
	
	  return ContactForm;
	}(_react2.default.Component);
	
	ContactForm.propTypes = {
	  handleSubmit: _propTypes2.default.func.isRequired,
	  hubspotId: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'contactForm',
	  touchOnBlur: false
	})(ContactForm);
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = HeroIllustration;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(17);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _generalModule = __webpack_require__(252);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	var _illustrationModule = __webpack_require__(251);
	
	var _illustrationModule2 = _interopRequireDefault(_illustrationModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_extends({}, _generalModule2.default, _illustrationModule2.default));
	
	function HeroIllustration(_ref) {
	  var children = _ref.children,
	      color = _ref.color,
	      copy = _ref.copy,
	      headingMaxWidth = _ref.headingMaxWidth,
	      imageMaxWidth = _ref.imageMaxWidth,
	      _ref$isContactUsPage = _ref.isContactUsPage,
	      isContactUsPage = _ref$isContactUsPage === undefined ? false : _ref$isContactUsPage,
	      src = _ref.src,
	      title = _ref.title,
	      tag = _ref.tag;
	
	  var heroClassName = cx('hero');
	  var illustrationClassName = cx('illustration');
	
	  return _react2.default.createElement(
	    'div',
	    { className: heroClassName },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      { size: 'l' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'padding', size: 'xl', position: 'topBottom' },
	        _react2.default.createElement(
	          _grid2.default,
	          { columns: 12, alignItems: 'center' },
	          _react2.default.createElement(
	            _grid.GridItem,
	            { columnSpan: 12, columnSpanM: 5 },
	            _react2.default.createElement(
	              _align2.default,
	              { type: 'center', typeM: 'left' },
	              _react2.default.createElement(
	                Container,
	                {
	                  isContactUsPage: isContactUsPage,
	                  headingMaxWidth: headingMaxWidth
	                },
	                _react2.default.createElement(
	                  _heading2.default,
	                  { tag: tag, size: 'xxxl', color: color, weight: 'bold' },
	                  title
	                ),
	                copy && _react2.default.createElement(
	                  _spacing2.default,
	                  { type: 'margin', size: 'xs', position: 'top' },
	                  _react2.default.createElement(
	                    _paragraph2.default,
	                    { size: 'l', color: color },
	                    copy
	                  )
	                ),
	                children
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _grid.GridItem,
	            { columnSpan: 12, columnSpanM: 7 },
	            _react2.default.createElement(
	              'div',
	              { className: illustrationClassName },
	              src && _react2.default.createElement(_Image2.default, {
	                alt: title,
	                maxWidth: imageMaxWidth,
	                src: src,
	                hasShadow: false,
	                useImageTag: true
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	var validColors = ['white', 'black', 'steel', 'slate', 'silver', 'darkSmoke', 'extraDarkSmoke', 'smoke', 'darkSnow', 'extraDarkSnow', 'snow'];
	
	var validTags = ['h1', 'h2'];
	
	function Container(_ref2) {
	  var isContactUsPage = _ref2.isContactUsPage,
	      children = _ref2.children,
	      headingMaxWidth = _ref2.headingMaxWidth;
	
	  if (isContactUsPage) return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        paddingLeft: '15%',
	        paddingRight: '15%'
	      }
	    },
	    children
	  );
	  return _react2.default.createElement(
	    _maxWidth2.default,
	    { value: headingMaxWidth, display: 'inlineBlock' },
	    children
	  );
	}
	
	Container.propTypes = {
	  isContactUsPage: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  headingMaxWidth: _propTypes2.default.number
	};
	
	HeroIllustration.propTypes = {
	  children: _propTypes2.default.node,
	  copy: _propTypes2.default.string,
	  headingMaxWidth: _propTypes2.default.number,
	  imageMaxWidth: _propTypes2.default.number,
	  isContactUsPage: _propTypes2.default.bool,
	  src: _propTypes2.default.string,
	  title: _customPropTypesCheck2.default,
	  color: _propTypes2.default.oneOf(validColors),
	  tag: _propTypes2.default.oneOf(validTags)
	};
	
	HeroIllustration.defaultProps = {
	  imageMaxWidth: 660,
	  headingMaxWidth: 460,
	  color: 'black',
	  tag: 'h1'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"illustration":"src-components-modules-Hero-HeroIllustration-style----illustration-module---illustration---OByMU textAlign-center centered"};

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = MediaSingleImage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _bind = __webpack_require__(17);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Shape = __webpack_require__(27);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _Diamonds = __webpack_require__(181);
	
	var _Diamonds2 = _interopRequireDefault(_Diamonds);
	
	var _contentModule = __webpack_require__(255);
	
	var _contentModule2 = _interopRequireDefault(_contentModule);
	
	var _generalModule = __webpack_require__(256);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	var _imageModule = __webpack_require__(257);
	
	var _imageModule2 = _interopRequireDefault(_imageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_extends({}, _contentModule2.default, _generalModule2.default, _imageModule2.default));
	
	function MediaSingleImage(_ref) {
	  var alt = _ref.alt,
	      children = _ref.children,
	      copy = _ref.copy,
	      hasShadow = _ref.hasShadow,
	      headingSpacing = _ref.headingSpacing,
	      imageBorderRadius = _ref.imageBorderRadius,
	      justify = _ref.justify,
	      justifyM = _ref.justifyM,
	      maxWidth = _ref.maxWidth,
	      paragraphSize = _ref.paragraphSize,
	      reversed = _ref.reversed,
	      shapes = _ref.shapes,
	      src = _ref.src,
	      title = _ref.title;
	
	  var singleImageClassName = cx('singleImage');
	  var imageClassName = cx('image', {
	    imageReversed: reversed
	  });
	  var contentClassName = cx('content', {
	    contentReversed: reversed
	  });
	
	  var contentProps = {
	    copy: copy,
	    justify: justify,
	    justifyM: justifyM,
	    paragraphSize: paragraphSize,
	    spacing: headingSpacing,
	    title: title
	  };
	
	  var ImageProps = {
	    alt: alt,
	    borderRadius: imageBorderRadius,
	    maxWidth: maxWidth || 1200,
	    src: src
	  };
	
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      'div',
	      { className: singleImageClassName },
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { maxWidth: 770 },
	        src && _react2.default.createElement(
	          _spacing2.default,
	          { size: 'l', type: 'margin', position: 'bottom' },
	          _react2.default.createElement(_Image2.default, _extends({}, ImageProps, { hasShadow: hasShadow }))
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: contentClassName },
	        _react2.default.createElement(
	          _HeadingBlock2.default,
	          contentProps,
	          children
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: imageClassName },
	        shapes && _react2.default.createElement(
	          _reactResponsive2.default,
	          { minWidth: 770 },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_Shape2.default, {
	              width: 300,
	              height: 300,
	              type: 'losange',
	              color: 'yellow',
	              top: '50%',
	              left: '-3%'
	            }),
	            _react2.default.createElement(_Diamonds2.default, { top: '50%', left: '-4%', size: 220 })
	          )
	        ),
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { minWidth: 770 },
	          src && _react2.default.createElement(_Image2.default, _extends({}, ImageProps, { hasShadow: hasShadow }))
	        )
	      )
	    )
	  );
	}
	
	MediaSingleImage.propTypes = {
	  alt: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  copy: _propTypes2.default.string,
	  hasShadow: _propTypes2.default.bool,
	  headingSpacing: _customPropTypesCheck2.default,
	  imageBorderRadius: _propTypes2.default.string,
	  justify: _propTypes2.default.string,
	  justifyM: _propTypes2.default.string,
	  maxWidth: _propTypes2.default.number,
	  paragraphSize: _propTypes2.default.string,
	  reversed: _propTypes2.default.bool,
	  shapes: _propTypes2.default.bool,
	  src: _propTypes2.default.string,
	  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
	};
	
	MediaSingleImage.defaultProps = {
	  hasShadow: true,
	  headingSpacing: 'l',
	  imageBorderRadius: 'l',
	  reversed: false,
	  shapes: false
	};
	module.exports = exports['default'];

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"src-components-modules-Media-MediaSingleImage-style----content-module---content---h7dJy breakPointM-width-40 breakPointM-position-absolute height-100 position-static width-100","contentReversed":"src-components-modules-Media-MediaSingleImage-style----content-module---contentReversed---3tN5l"};

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"singleImage":"src-components-modules-Media-MediaSingleImage-style----general-module---singleImage---BWXmW position-relative"};

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image":"src-components-modules-Media-MediaSingleImage-style----image-module---image---iRly0","imageReversed":"src-components-modules-Media-MediaSingleImage-style----image-module---imageReversed---1InNH"};

/***/ }),

/***/ 1225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _illustration2x = __webpack_require__(2547);
	
	var _illustration2x2 = _interopRequireDefault(_illustration2x);
	
	var _press2x = __webpack_require__(2548);
	
	var _press2x2 = _interopRequireDefault(_press2x);
	
	var _sales2x = __webpack_require__(2549);
	
	var _sales2x2 = _interopRequireDefault(_sales2x);
	
	var _supportNew2x = __webpack_require__(2550);
	
	var _supportNew2x2 = _interopRequireDefault(_supportNew2x);
	
	var _grid2x = __webpack_require__(2546);
	
	var _grid2x2 = _interopRequireDefault(_grid2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  illustration: {
	    alt: '',
	    src: _illustration2x2.default
	  },
	  press: {
	    alt: '',
	    src: _press2x2.default
	  },
	  sales: {
	    alt: '',
	    src: _sales2x2.default
	  },
	  support: {
	    alt: '',
	    src: _supportNew2x2.default
	  },
	  office: {
	    alt: '',
	    src: _grid2x2.default,
	    maxWidth: 804
	  }
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 2546:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/grid@2x-8681308f79a54f684cffd13082dabd56.jpg";

/***/ }),

/***/ 2547:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/illustration@2x-85cce263ddf60035c6702cc57dd1fc2a.jpg";

/***/ }),

/***/ 2548:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/press@2x-f25f9f67f3f3a2632496efebb38294b3.png";

/***/ }),

/***/ 2549:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sales@2x-b45edaba8ae8ae9dad578ed0db284985.png";

/***/ }),

/***/ 2550:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/supportNew@2x-b36e01a4175100516c5770328f93c7f9.png";

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ContactCard;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _ArrowButton = __webpack_require__(74);
	
	var _ArrowButton2 = _interopRequireDefault(_ArrowButton);
	
	var _Card = __webpack_require__(76);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _SmartLink = __webpack_require__(36);
	
	var _SmartLink2 = _interopRequireDefault(_SmartLink);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContactCard(_ref) {
	  var title = _ref.title,
	      copy = _ref.copy,
	      url = _ref.url,
	      image = _ref.image;
	
	  return _react2.default.createElement(
	    _Card2.default,
	    null,
	    _react2.default.createElement(
	      _align2.default,
	      { type: 'center' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'margin', size: 'l', position: 'topBottom' },
	        _react2.default.createElement(_Image2.default, _extends({}, image, { maxWidth: 144, hasShadow: false }))
	      ),
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'margin', size: 'xs', position: 'bottom' },
	        _react2.default.createElement(
	          _heading2.default,
	          { weight: 'semibold', size: 'xl' },
	          title
	        )
	      ),
	      _react2.default.createElement(
	        _maxWidth2.default,
	        { value: 240 },
	        _react2.default.createElement(
	          _paragraph2.default,
	          { size: 'm', color: 'slate' },
	          copy
	        )
	      ),
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'padding', size: 'm', position: 'topBottom' },
	        _react2.default.createElement(
	          _SmartLink2.default,
	          { url: url },
	          _react2.default.createElement(_ArrowButton2.default, null)
	        )
	      )
	    )
	  );
	}
	
	ContactCard.propTypes = {
	  copy: _customPropTypesCheck2.default,
	  image: _propTypes2.default.object,
	  title: _customPropTypesCheck2.default,
	  url: _customPropTypesCheck2.default,
	  isExternal: _propTypes2.default.bool
	};
	
	ContactCard.defaultProps = {
	  isExternal: false
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1258:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ContactUs;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _ContactForm = __webpack_require__(1162);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _HeroIllustration = __webpack_require__(203);
	
	var _HeroIllustration2 = _interopRequireDefault(_HeroIllustration);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _MediaSingleImage = __webpack_require__(207);
	
	var _MediaSingleImage2 = _interopRequireDefault(_MediaSingleImage);
	
	var _OffsetBackground = __webpack_require__(77);
	
	var _OffsetBackground2 = _interopRequireDefault(_OffsetBackground);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _ParallaxWrapper = __webpack_require__(28);
	
	var _ParallaxWrapper2 = _interopRequireDefault(_ParallaxWrapper);
	
	var _Whitespace = __webpack_require__(35);
	
	var _Whitespace2 = _interopRequireDefault(_Whitespace);
	
	var _ArrowLink = __webpack_require__(75);
	
	var _ArrowLink2 = _interopRequireDefault(_ArrowLink);
	
	var _assets = __webpack_require__(1225);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _hubspot = __webpack_require__(46);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _ContactCard = __webpack_require__(639);
	
	var _ContactCard2 = _interopRequireDefault(_ContactCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportLinks = [{
	  image: _assets2.default.sales,
	  title: 'Sales',
	  copy: 'For purchasing Marvel Enterprise and multi-year plans',
	  url: 'mailto:sales@marvelapp.com'
	}, {
	  copy: 'Need help with Marvel? Report issues and ask questions here',
	  image: _assets2.default.support,
	  title: 'Support',
	  url: 'https://help.marvelapp.com/hc/en-us/requests/new'
	}, {
	  copy: 'Download our brand pack including logos and product shots',
	  image: _assets2.default.press,
	  title: 'Press Kit',
	  url: 'https://www.dropbox.com/sh/nzv8j2bvjgi9jzz/AAB8jc2jQRRg022GqJKhPJOma?dl=0'
	}];
	
	var url = "https://www.google.com/maps/place/7-10+Bateman's+Row,+Hackney,+London+EC2A+3HH/data=!4m2!3m1!1s0x48761cb08076337b:0xfac604bd39278c8b?sa=X&ved=2ahUKEwi50bf73vPmAhVFnVwKHYeeA74Q8gEwAHoECAsQAQ";
	
	function ContactUs() {
	  var title = _react2.default.createElement(
	    'div',
	    null,
	    'How to find Marvel HQ'
	  );
	  var headingCopy = 'Drop us a line';
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: _metadata2.default['contact-us'].title,
	      meta: [{ name: 'description', content: _metadata2.default['contact-us'].description }, { name: 'keywords', content: _metadata2.default['contact-us'].keywords }],
	      header: true,
	      footer: true
	    },
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'padding', size: 'l', position: 'topBottom' },
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { maxWidth: 769 },
	        _react2.default.createElement(
	          _pageWrap2.default,
	          null,
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { type: 'padding', size: 'l' },
	              _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.illustration, { hasShadow: false }))
	            ),
	            _react2.default.createElement(
	              _heading2.default,
	              { tag: 'h2', size: 'xxxxl', weight: 'semibold' },
	              headingCopy
	            )
	          ),
	          _react2.default.createElement(_ContactForm2.default, { hubspotId: _hubspot.formContactUs })
	        )
	      ),
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { minWidth: 770 },
	        _react2.default.createElement(
	          _HeroIllustration2.default,
	          _extends({}, _assets2.default.illustration, {
	            imageMaxWidth: 655,
	            isContactUsPage: true,
	            headingMaxWidth: 600,
	            title: headingCopy,
	            tag: 'h1'
	          }),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', position: 'topBottom', sizeM: 'l' },
	            _react2.default.createElement(_ContactForm2.default, { hubspotId: _hubspot.formContactUs })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'margin', size: '0', sizeM: 'xl', position: 'topBottom' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'padding', size: 'xl', sizeM: '0', position: 'topBottom' },
	          _react2.default.createElement(_HeadingBlock2.default, {
	            title: 'Looking for something in particular?',
	            alignContent: 'center'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'bg-marvel breakPointM-bg-none' },
	          _react2.default.createElement(
	            _OffsetBackground2.default,
	            { height: 70 },
	            _react2.default.createElement(
	              _pageWrap2.default,
	              { size: 'l' },
	              _react2.default.createElement(
	                _spacing2.default,
	                {
	                  type: 'padding',
	                  size: 'l',
	                  sizeM: 'xl',
	                  position: 'topBottom'
	                },
	                _react2.default.createElement(
	                  _ParallaxWrapper2.default,
	                  { speed: 1.4, positionAbsolute: false },
	                  _react2.default.createElement(
	                    _grid2.default,
	                    { columns: 12 },
	                    /* eslint-disable no-shadow */
	                    supportLinks.map(function (_ref) {
	                      var linkCopy = _ref.copy,
	                          image = _ref.image,
	                          linkTitle = _ref.title,
	                          url = _ref.url;
	                      return _react2.default.createElement(
	                        _grid.GridItem,
	                        {
	                          columnSpan: 12,
	                          columnSpanM: 4,
	                          key: linkTitle
	                        },
	                        _react2.default.createElement(_ContactCard2.default, {
	                          copy: linkCopy,
	                          image: image,
	                          imgUrl: '#',
	                          title: linkTitle,
	                          url: url
	                        })
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'padding', size: 'l', sizeM: 'xl', position: 'topBottom' },
	        _react2.default.createElement(
	          _MediaSingleImage2.default,
	          _extends({}, _assets2.default.office, {
	            justifyContent: 'center',
	            reversed: true,
	            title: title,
	            imageBorderRadius: 'none',
	            hasShadow: false
	          }),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'padding', size: 'l', sizeM: 'xl', position: 'top' },
	            _react2.default.createElement(
	              _heading2.default,
	              { size: 'xl', weight: 'semibold' },
	              'London'
	            ),
	            _react2.default.createElement(
	              _spacing2.default,
	              { type: 'margin', size: 'm', position: 'topBottom' },
	              _react2.default.createElement(
	                _paragraph2.default,
	                { size: 'm' },
	                "7-10 Bateman's Row"
	              ),
	              _react2.default.createElement(
	                _paragraph2.default,
	                { size: 'm' },
	                'London'
	              ),
	              _react2.default.createElement(
	                _paragraph2.default,
	                { size: 'm' },
	                'EC2A 3HH'
	              )
	            ),
	            _react2.default.createElement(
	              _link2.default,
	              { url: url, target: '_blank' },
	              _react2.default.createElement(
	                _ArrowLink2.default,
	                null,
	                'Open in Google Maps'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { minWidth: 770 },
	        _react2.default.createElement(_Whitespace2.default, { sizeM: 'l' })
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ContactUsInput;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _input = __webpack_require__(517);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _inputLabel = __webpack_require__(516);
	
	var _inputLabel2 = _interopRequireDefault(_inputLabel);
	
	var _popover = __webpack_require__(66);
	
	var _popover2 = _interopRequireDefault(_popover);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _position = __webpack_require__(44);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _fieldsModule = __webpack_require__(486);
	
	var _fieldsModule2 = _interopRequireDefault(_fieldsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function ContactUsInput(_ref) {
	  var input = _ref.input,
	      _ref$meta = _ref.meta,
	      touched = _ref$meta.touched,
	      error = _ref$meta.error,
	      invalid = _ref$meta.invalid,
	      valid = _ref$meta.valid,
	      submitFailed = _ref$meta.submitFailed,
	      label = _ref.label,
	      id = _ref.id,
	      _ref$isTextarea = _ref.isTextarea,
	      isTextarea = _ref$isTextarea === undefined ? false : _ref$isTextarea,
	      rest = _objectWithoutProperties(_ref, ['input', 'meta', 'label', 'id', 'isTextarea']);
	
	  var Component = isTextarea ? _input.Textarea : _input2.default;
	  return _react2.default.createElement(
	    'div',
	    { className: 'position-relative' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'margin', size: 'xxs', position: 'bottom' },
	      _react2.default.createElement(
	        _position2.default,
	        { type: 'relative' },
	        _react2.default.createElement(
	          _inputLabel2.default,
	          { fontWeight: 'regular', htmlFor: id },
	          label
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _position2.default,
	      { type: 'relative' },
	      touched && typeof error === 'string' && _react2.default.createElement(
	        _popover2.default,
	        {
	          align: 'right',
	          alignContent: 'right',
	          fullWidth: true,
	          isActive: invalid,
	          maxWidth: 300,
	          position: 'top',
	          size: 'small',
	          type: 'error'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _fieldsModule2.default.popover },
	          error
	        )
	      ),
	      _react2.default.createElement(Component, _extends({}, input, rest, {
	        hasError: !!(touched && error),
	        showTick: touched && valid && submitFailed,
	        id: id
	      }))
	    )
	  );
	}
	
	ContactUsInput.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  input: _propTypes2.default.object.isRequired,
	  isTextarea: _propTypes2.default.bool,
	  label: _propTypes2.default.string.isRequired,
	  meta: _propTypes2.default.object.isRequired
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-us-index-js-9bafd0d77ec9d82bdbb3.js